import { createContext, useContext, useState, useEffect } from 'react';

export const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
    // Load from localStorage initially
    const [sessionId, setSessionId] = useState(() => localStorage.getItem("sessionId"));

    // Store it back to localStorage when it changes
    useEffect(() => {
        if (sessionId) {
            localStorage.setItem("sessionId", sessionId);
        }
    }, [sessionId]);

    return (
        <SessionContext.Provider value={{ sessionId, setSessionId }}>
            {children}
        </SessionContext.Provider>
    );
};

export const useSession = () => useContext(SessionContext);
